<template>
  <div id="album">
    <div class="container">
      <AlbumComponent v-if="currentEvent " />
    </div>
  </div>
</template>

<script>
import $ from "jquery"

import InfoBlock from "../modules/InfoBlock";
import AlbumComponent from "../components/event/Album.vue";
export default {
  name: "album",
  components: { AlbumComponent, InfoBlock },
  methods: {},
  mounted() {
      $("html, body").animate({ scrollTop: 0 }, 350);
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
  }
};
</script>

<style lang="less">
#album {
  background-color: #F1F3F6;

  
  min-height: calc(~"100vh");
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 20px;

  .container {
    display: block;
    max-width: 1120px;
    width: inherit;
    margin: 0 auto;
    margin-bottom: 40px;
  }
}

@media (max-width: 768px) {
  #album {
    padding: 0px;
    padding-bottom: 60px;
    .container {
      padding: 0px 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Album.vue